<template>
  <validation-observer
    ref="observer"
    slim
  >
    <form
      v-bind="$props"
      @submit.prevent="onSubmit"
    >
      <slot />
    </form>
  </validation-observer>
</template>

<script>

export default {
  name: 'QForm',
  methods: {
    async onSubmit (event) {
      const valid = await this.$refs.observer.validate()
      this.$emit('submit', { valid, ...event })
    },
  },
}
</script>
